import React from 'react'
import { resume } from '../assets/data/Resume'
import Hero from '../components/Hero/Hero'
import Showcase from '../components/Showcase/Showcase'
import ScrollToTop from '../utils/ScrollToTop'


const styles = {
    padding: '4rem 0',
    borderTop: '1px solid var(--grey-clr)',
    borderBottom: '1px solid var(--grey-clr)',
    fontSize: 'var(--paragraph-fz)',
    lineHeight: 1.6,
}

const About = () => {
    ScrollToTop()
    return (
        <>
            <Hero button={false} />
            <div style={styles}>
                <div className="about-paragraph" id="container">
                    <p>My name is Adda Younes Abdelatif, I'm 20 years old from Algeria, Studying Informations Systems Engineering in National Polytechnic School of Oran, I mostly work as a Frontend Developer freelancer, using web technologies such as React, Vue and more... I'm also a Graphic Designer with a good amount of knowledge in UI & UX Design, I've designed and developed many projects, some of them are listed in my portfolio section and the rest in my Github account (listed down in the footer). <br />I love learning new technologies & stuff, I'm interested in many fields such as Tech, Economy, Sports, Photography & Filmmaking, Movies & Series, Art...<br />If you'de like to know more about me and my experience I invite you to take a look at me <b>resume</b> down below.</p>
                </div>
            </div>
            <Showcase {...resume} />
        </>
    )
}

export default About
